// extracted by mini-css-extract-plugin
export default {"DateAtt":"Ledger_DateAtt__bsfbL","DateWrapperClass":"Ledger_DateWrapperClass__GebCE"};